<ng-progress></ng-progress>

<stzh-header
  [menuItems]="headerMenuItems"
  [metanavItems]="headerMetanavItems"
  href="https://submissionen-hochbau.stadt-zuerich.ch/#">
  <img slot="logo" src="assets/media/logo/logo_hochbau_2.svg" alt="Amt für Hochbauten Stadt Zürich">
</stzh-header>

<main data-modal="main" class="main">
  <stzh-container>
    <div class="layout_wrapper">
    @if (signedIn) {
      <div class="mod_topnav">
        <ul>
          <li routerLink="" routerLinkActive="var_active" [routerLinkActiveOptions]="{ exact: true }">
            <a>Meine Ausschreibungen</a>
          </li>
          @if (id != '-1') {
            <li [routerLink]="['/ausschreibung', id]"
              routerLinkActive="var_active"
              [routerLinkActiveOptions]="{ exact: true }">
              <a>{{selectedAusschreibungTitle}}</a>
            </li>
          }
          @if (angebot) {
            <li [routerLink]="['/angebot/', id]"
              routerLinkActive="var_active"
              [routerLinkActiveOptions]="{ exact: true }">
              <a>Ihr Angebot</a>
            </li>
          }
        </ul>
      </div>
    }
    <div class="layout_section">
      <router-outlet></router-outlet>
    </div>
    </div>
  </stzh-container>
</main>

@if (isLanding) {
  <stzh-footer [copyright]="'© ' + year + ' Stadt Zürich'">
    <div slot="info" class="footer-info">
      <div class="footer-links">
        <stzh-link [href]="addBaseUrl('ahb-hilfe-angebotseingabe')">Hilfe zur Angebotseingabe</stzh-link>
        <stzh-link [href]="addBaseUrl('de/service/mein-konto/hilfe.html')">Hilfeseiten rund um «Mein Konto»</stzh-link>
        <stzh-link [href]="addBaseUrl('hbd')">Über das Hochbaudepartement der Stadt Zürich</stzh-link>
      </div>
      <address class="footer-address">
          Amt für Hochbauten<br />
          Walchestrasse 31/33<br />
          Postfach, 8021 Zürich
      </address>
    </div>
    <stzh-link slot="link" [href]="addBaseUrl('ausschreibungsplattform-ahb-rechtliche-hinweise')">Rechtliche Hinweise</stzh-link>
    <stzh-link slot="link" [href]="addBaseUrl('ausschreibungsplattform-ahb-impressum')">Impressum</stzh-link>
    <stzh-link slot="link" [href]="addBaseUrl('ausschreibungsplattform-ahb-barrierefreiheit')">Barrierefreiheit</stzh-link>
  </stzh-footer>
} @else {
  <stzh-footer
    variant="egov"
    [copyright]="'© ' + year + ' Stadt Zürich'"
    [mainUrl]="footerMainUrl"
    [localization]="footerLocalization">
    <stzh-link slot="info" [href]="addBaseUrl('ahb-hilfe-angebotseingabe')" target="_blank">Hilfe zur Angebotseingabe</stzh-link>
  </stzh-footer>
}
